import { FC } from 'react';
import { useIsFrontendStyleRed } from '@edikk-edikk/country-frontend';
import classNames from 'classnames';
import menuControlsActionCss from '#baseMenu/assets/menu-controls-action.module.scss';
import { AppSvgSpriteMonoIcon } from '#src/svg';

const ButtonOpenSvgIcon: FC = () => {
  const isFrontendStyleRed = useIsFrontendStyleRed();

  if (isFrontendStyleRed) {
    return (
      <AppSvgSpriteMonoIcon
        name="menu-alt"
        size={20}
        className={classNames(
          menuControlsActionCss.menuControlsAction__icon,
          menuControlsActionCss.menuControlsAction__icon_styleRed,
        )}
      />
    );
  }

  return <AppSvgSpriteMonoIcon name="menu" size={20} />;
};

export { ButtonOpenSvgIcon };
